import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

import { JsonSchemaFormProperty } from '@connect-services/client/sdk/api';
import { JsonSchemaFieldInterventionFormControl } from '@connect-services/client/services/json-form.service';
import { CustomColumn, CustomTableComponent } from '@connect-services/src/lib/components/table/table.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CustomTableComponent, TranslocoPipe],
    selector: 'app-controls-list',
    templateUrl: './controls-list.component.html',
})
export class ControlsListComponent {
    public readonly controls = input.required<JsonSchemaFieldInterventionFormControl[]>();
    public tableColumns: CustomColumn[] = [
        {
            key: 'title',
            label: 'title',
            sortable: false,
        },
        {
            key: 'description',
            label: 'description',
            sortable: false,
        },
        {
            key: 'type',
            label: 'type',
            sortable: false,
        },
        {
            key: 'possibleValues',
            label: 'possibleValues',
            sortable: false,
        },
        {
            key: 'required',
            label: 'required',
            sortable: false,
        },
    ];

    public getPossibleValues(control: JsonSchemaFieldInterventionFormControl): string[] {
        if (control.enumeration?.length) {
            return control.enumeration;
        }

        if (control.type === JsonSchemaFormProperty.TypeEnum.ARRAY && control.items?.enumeration?.length) {
            return control.items.enumeration;
        }

        return ['-'];
    }
}
